export default __webpack_public_path__ + "static/media/guess-player.6d787621.svg";